/**
 * DcDialog.js
 * 
 * DC-FE-DCDIALOG-TDD-GREEN-001: Reusable confirmation dialog component
 * 
 * A simple blocking confirm/cancel dialog for destructive or informational actions.
 * Supports "default", "danger", and "info" variants.
 */

import React from "react";

const DcDialog = ({
  isOpen,
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default",
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) {
    return null;
  }

  const dialogClassName = `dc-dialog ${variant === "info" ? "dc-dialog-info" : ""} ${variant === "danger" ? "dc-dialog-danger" : ""}`.trim();
  const confirmButtonClassName = `dc-dialog-confirm-button ${variant === "danger" ? "danger" : ""}`.trim();

  return (
    <div
      data-testid="dc-dialog-overlay"
      className="dc-dialog-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className={dialogClassName}
        data-testid="dc-dialog"
        style={{
          backgroundColor: "#fff",
          padding: "16px 20px",
          borderRadius: "8px",
          minWidth: "280px",
          maxWidth: "480px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
      >
        <h2 className="dc-dialog-title">{title}</h2>
        <div className="dc-dialog-body">{body}</div>
        <div className="dc-dialog-actions">
          <button
            className="dc-dialog-cancel-button"
            onClick={() => onCancel && onCancel()}
          >
            {cancelLabel}
          </button>
          <button
            className={confirmButtonClassName}
            onClick={() => onConfirm && onConfirm()}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DcDialog;
